module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-flex', {
    staticClass: "text-black glosario",
    attrs: {
      "text-xs-center": ""
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', [_c('span', {
      staticClass: "name font-red"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.glosario) ? _c('ui-simple-lsc', {
      attrs: {
        "id": 'video' + index,
        "videoglosario": true,
        "videoId": index,
        "active": item.videoAcc,
        "vidTittle": item.name,
        "videoEmbed": item.link
      },
      on: {
        "hideVideo": _vm.hideVideo
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "definition"
    }, [_c('p', [_vm._v(_vm._s(item.definition))])])], 1)
  })), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": "",
      "justify-center": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "https://misfinanzasencasa.davivienda.com/diccionario-financiero",
      "target": "_blank"
    }
  }, [_c('v-layout', {
    staticClass: "BotonDic hvr-grow",
    attrs: {
      "text-xs-center": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm2": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSrc": "logos-icons/glosarioIcono",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm10": ""
    }
  }, [_c('div', [_vm._v("Diccionario"), _c('br'), _vm._v("Financiero")]), _vm._v(" "), _c('span')])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ee98293","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Glosario.vue
// module id = 964
// module chunks = 1